import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import SmallStoryCardWithTopBorder from "../molecules/smallStoryCardWithTopBorder";
import { More } from "../atoms/load-more-btn/index";

import "./section.m.css";

const template = stories => {
  return (
    <>
      {stories.map(story => (
        <SmallStoryCardWithTopBorder story={story} key={story.id} />
      ))}
    </>
  );
};

const TagPageBase = ({ data, hostUrl }) => {
  const { stories, tag, pageNumber } = data;

  if (!(stories && stories.length)) {
    return null;
  }

  const slug = `${hostUrl}/topic/${tag.slug}?page=${pageNumber ? parseInt(pageNumber) + 1 : 2}`;

  return (
    <div>
      <h1>{tag.name}</h1>
      {template(stories)}
      {stories.length > 10 && (
        <a styleName="button-container" href={slug}>
          <More text="আরও" />
        </a>
      )}
    </div>
  );
};

TagPageBase.propTypes = {
  data: PropTypes.object
};

const mapStateToProps = state => {
  return {
    hostUrl: get(state, ["qt", "config", "publisher-attributes", "host_url"], {})
  };
};

export const TagPage = connect(mapStateToProps)(TagPageBase);
